/**
 * O que a navegação da câmera está fazendo agora, para quem trata o mesmo
 * teclado e o mesmo mouse (arrastar peças, atalhos de ferramenta) saber que o
 * gesto é da câmera e não é dele.
 */
export const estadoNavegacao = {
  /** Espaço apertado: arrastar com o botão esquerdo move a cena, como na mão do Photoshop. */
  espaco: false,
  /** Botão direito apertado: W A S D andam pela cena, como nos editores 3D. */
  botaoDireito: false,
}

/** Teclas que andam pela cena com o botão direito apertado → a tecla de seta equivalente. */
export const TECLAS_DE_ANDAR: Readonly<Record<string, string>> = {
  w: 'ArrowUp',
  s: 'ArrowDown',
  a: 'ArrowLeft',
  d: 'ArrowRight',
  e: 'PageUp',
  q: 'PageDown',
}
